/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
//import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import classnames from 'classnames';

import { IProductSpecificationViewProps } from './vinhuset-product-specification';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps> = (props) => {
    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableBodyProps,
        productSpecificationResult,
        curatedInformation,
        footer
    } = props;

    const classNameBase = 'ms-product-specification';

    const [selectedTab, setSelectedTab] = React.useState(0);

    if (!productSpecificationResult) {
        return null;
    }

    const pages: {
        heading: string;
        subHeader: JSX.Element | null;
        content: JSX.Element;
    }[] = [];

    productSpecificationResult.forEach((table: any, index: number) => {
        if (!table || table.tableData.length === 0) {
            return null;
        }

        const heading = table.heading.props.text;
        const subHeader = table.subHeader;
        const content = (
            <Node {...ProductSpecificationTableProps} data-model-version={table.modelVersion}>
                <Node {...ProductSpecificationTableBodyProps}>{table.tableData}</Node>
            </Node>
        );

        return pages.push({ heading, subHeader, content });
    });

    if (props.addionalMedia) {
        pages.push({
            heading: props.resources.additionalTabLabel,
            subHeader: null,
            content: props.addionalMedia as JSX.Element
        });
    }

    props.slots?.tabs?.forEach((tab, index: number) => {
        pages.push({
            heading: (tab as JSX.Element).props?.config?.title || `Tab ${index + 1}`,
            subHeader: null,
            content: tab as JSX.Element
        });
    });

    return (
        <Module {...ProductSpecification}>
            {curatedInformation}
            {props.slots.productSheet}
            <div className={`${classNameBase}__tabs-header`}>
                {pages.map((page, index) => {
                    return (
                        <button
                            key={index}
                            className={classnames(`${classNameBase}__tab`, { selected: selectedTab === index })}
                            onClick={() => setSelectedTab(index)}
                        >
                            {page.heading}
                        </button>
                    );
                })}
            </div>
            <div className={`${classNameBase}__grid`}>
                {pages.map((page, index) => {
                    return (
                        <div key={page.heading.toLowerCase()} className={classnames(`${classNameBase}__group`, {
                            collapsed: selectedTab !== index,
                            expanded: selectedTab === index
                        })}>
                            {page.subHeader}
                            {page.content}
                        </div>
                    );
                })}
            </div>
            {footer}
        </Module>
    );
};

export default ProductSpecificationView;
